import { SxProps, Theme } from '@mui/material';

export const wrapperStyles: SxProps<Theme> = {
  bgcolor: 'grey.100',
  minHeight: '100vh',
  minWidth: '100vw',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const cardFormStyles: SxProps<Theme> = {
  width: { xs: '100%', md: 450 },
  p: { xs: 3, md: 6 },
};
